(() => {
  if (window.__ckMarketSwitcherInit) return;
  window.__ckMarketSwitcherInit = true;

  // Ensure utils is loaded
  if (typeof window.requireUtils === 'function') {
    window.requireUtils('market-switcher.js');
  }

  if (!window.utils) {
    console.error('[market-switcher] Utils not loaded!');
    return;
  }

  const ROOT = '[data-market-switcher]';
  const ITEM = '[data-market-switcher-item]';
  const TRIGGER = '[data-market-switcher-trigger]';

  const norm = (v) => (window.utils?.normalizeStringValue(v) || '').trim().toLowerCase();
  const parseShopifyUrl =
    window.utils?.parseShopifyUrl || (() => ({ market: null, lang: 'en', remainder: [] }));
  const buildShopifyUrl = window.utils?.buildShopifyUrl || (() => '/');
  const mapMarketHandleToUrlCode = window.utils?.mapMarketHandleToUrlCode || ((h) => h);

  /**
   * Get market name from market handle
   * @param {string} marketHandle - Market handle (e.g., 'eu', 'uk')
   * @returns {string} Market name in uppercase
   */
  const getMarketName = (marketHandle) => {
    return (marketHandle || 'uk').toUpperCase();
  };

  /**
   * Detect current market from URL
   * @returns {string} Market handle ('eu', 'uk', etc.) or 'uk' as default
   */
  const detectCurrentMarket = () => {
    const parsed = parseShopifyUrl(window.location.pathname);
    return parsed.market || 'uk';
  };

  /**
   * Update trigger text to show current market
   */
  const setTrigger = () => {
    const market = detectCurrentMarket();
    const label = getMarketName(market);
    document.querySelectorAll(ROOT).forEach((root) => {
      const el = root.querySelector(TRIGGER);
      if (el) {
        el.textContent = label;
      }
    });
  };

  /**
   * Navigate to target market, preserving path structure and language
   * @param {string} token - Market token (e.g., 'market-eu', 'market-uk')
   */
  /**
   * Extract market code from link URL
   * Handles formats: '#market-uk', 'market-uk', '/es-eumarket-uk', etc.
   * @param {string} linkUrl - Link URL from Shopify menu
   * @param {string} linkTitle - Link title (fallback)
   * @returns {string|null} Market code ('uk', 'eu', etc.) or null
   */
  const extractMarketCode = (linkUrl, linkTitle) => {
    if (!linkUrl || typeof linkUrl !== 'string') {
      // Fallback to title
      const titleLower = (linkTitle || '').trim().toLowerCase();
      if (titleLower === 'uk' || titleLower.includes('united kingdom')) return 'uk';
      if (titleLower === 'eu' || titleLower.includes('europe')) return 'eu';
      return null;
    }

    const urlLower = linkUrl.trim().toLowerCase();
    const cleanUrl = urlLower.replace(/^#/, '').replace(/^\//, '');

    // Extract market code from URL patterns: 'market-uk', 'market-eu', or ending with '-uk', '-eu'
    const marketMatch = cleanUrl.match(/market-([a-z]{2,})|([a-z]{2,})$/);
    if (marketMatch) {
      const code = marketMatch[1] || marketMatch[2];
      if (code && code.length >= 2) return code;
    }

    // Fallback to title
    const titleLower = (linkTitle || '').trim().toLowerCase();
    if (titleLower === 'uk' || titleLower.includes('united kingdom')) return 'uk';
    if (titleLower === 'eu' || titleLower.includes('europe')) return 'eu';

    return null;
  };

  const goMarket = (linkUrl, linkTitle) => {
    let targetMarket = extractMarketCode(linkUrl, linkTitle);

    if (!targetMarket) {
      console.error('[market-switcher] Could not determine target market');
      return;
    }

    targetMarket = mapMarketHandleToUrlCode(targetMarket);

    if (!targetMarket || typeof targetMarket !== 'string') {
      console.error('[market-switcher] Invalid targetMarket:', targetMarket);
      return;
    }

    const parsed = parseShopifyUrl(window.location.pathname);
    const isUK = targetMarket === 'uk';

    let newUrl;
    if (isUK) {
      // UK market: preserve remainder (current page path)
      const remainderForUrl = Array.isArray(parsed.remainder) ? [...parsed.remainder] : [];
      newUrl = buildShopifyUrl({
        lang: 'en',
        market: null,
        remainder: remainderForUrl,
      });
    } else {
      const langForUrl = parsed.lang || 'en';
      const remainderForUrl = Array.isArray(parsed.remainder) ? [...parsed.remainder] : [];
      newUrl = buildShopifyUrl({
        lang: langForUrl,
        market: targetMarket,
        remainder: remainderForUrl,
      });
    }

    const parsedNewUrl = parseShopifyUrl(newUrl);
    const targetLang = parsedNewUrl.lang || 'en';

    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem('__ck_target_lang', targetLang);
    }

    if (window.Weglot && typeof window.Weglot.switchTo === 'function') {
      try {
        window.Weglot.switchTo(targetLang);
      } catch (e) {
        console.warn('[market-switcher] Error triggering Weglot:', e);
      }
    }

    window.location.assign(newUrl);
  };

  /**
   * Handle market item click
   */
  document.addEventListener(
    'click',
    (e) => {
      const item = e.target?.closest?.(ITEM);
      if (!item) return;

      // Prevent default behavior and stop propagation
      e.preventDefault();
      e.stopPropagation();

      const linkUrl = item.getAttribute('data-market-url') || '';
      const linkTitle = item.getAttribute('data-market-title') || '';

      const root = item.closest?.(ROOT);
      if (root) {
        root.dispatchEvent(new CustomEvent('ck-popover-close', { bubbles: true, composed: true }));
      }

      goMarket(linkUrl, linkTitle);

      // Return false to prevent any other handlers
      return false;
    },
    true
  ); // Use capture phase to catch early

  const init = () => {
    setTrigger();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('popstate', init);
})();
